export function round(val: number) {
  if (val.toString().includes("e")) return val.toExponential(2);
  return Number(Math.round(+(val.toPrecision() + "e2")) + "e-2");
}
